const burgerMenu = ({ onClickOpen = () => {}, onClickClose = () => {} }) => {
  const burger = document.querySelector('.js-burger');
  const header = document.querySelector('.js-header');
  const body = document.body;

  if (!burger) return;

  burger.addEventListener('click', () => {
    if (burger.classList.contains('is-open')) {
      burger.classList.remove('is-open');
      burger.setAttribute('data-modal', '#mobile-menu');
      header.classList.remove('is-open');
      body.classList.remove('is-menu-open');
      body.classList.remove('is-overflow-hidden');

      onClickClose();
    } else {
      burger.classList.add('is-open');
      burger.setAttribute('data-modal', 'close');
      header.classList.add('is-open');
      body.classList.add('is-menu-open');
      body.classList.add('is-overflow-hidden');

      onClickOpen();
    }
  });
};
export { burgerMenu };

document.addEventListener('DOMContentLoaded', function () {
  const burger = document.querySelector('.js-burger');
  const mobileMenu = document.querySelector('.c-menu__mobile');
  const headerFlex = document.querySelector('.l-header__flex');

  if (burger && mobileMenu && headerFlex) {
    burger.addEventListener('click', () => {
      burger.classList.toggle('is-active');
      mobileMenu.classList.toggle('is-open');
      headerFlex.classList.toggle('js-active');
    });
  }
});
